class TechnicalSkills {
  constructor(data) {
    this.data = data || {
      "Programming Languages": ['JavaScript', 'TypeScript', 'Python', 'Java', 'Dart'],
      "Frameworks & Libraries": ['React', 'Angular', 'Flutter', 'Redux', 'Next.js', 'Node.js', 'Express'],
      "Backend / API Work": ['Node.js', 'Express', 'REST APIs', 'GraphQL', 'Spring Boot', 'API Gateway', 'Lambda', 'API Design', 'Authentication (JWT, OAuth)', 'Microservices'],
      "Databases": ['PostgreSQL', 'MongoDB', 'MySQL', 'Redis', 'Firebase', 'DynamoDB'],
      "Tools & Technologies": ['Docker', 'Webpack', 'Babel', 'ESLint', 'Prettier'],
      "Version Control": ['Git', 'GitHub'],
      "Cloud Platform": ['AWS', 'Vercel', 'Google Cloud Platform'],
      "DevOps/CI/CD": ['GitHub Actions', 'CircleCI', 'Jenkins'],
      "Operating Systems": ['Windows', 'Linux', 'macOS'],
      "Concepts & Methodologies": ['TDD', 'Agile', 'Responsive Design', 'Accessibility'],
      "Soft Skills": ['Communication', 'Leadership', 'Problem Solving', 'Collaboration']
    }
  }

  toObject() {
    return this.data
  }

  get(category) {
    return this.data[category] || []
  }

  categories() {
    return Object.keys(this.data)
  }

  addCategory(category, items = []) {
    this.data[category] = items
  }

  addSkill(category, skill) {
    if (!this.data[category]) this.data[category] = []
    if (!this.data[category].includes(skill)) this.data[category].push(skill)
  }
}

export default TechnicalSkills
